import { render, staticRenderFns } from "./dashboard_unidade.vue?vue&type=template&id=3f2e3068&scoped=true"
import script from "./dashboard_unidade.vue?vue&type=script&lang=js"
export * from "./dashboard_unidade.vue?vue&type=script&lang=js"
import style0 from "./dashboard_unidade.vue?vue&type=style&index=0&id=3f2e3068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e3068",
  null
  
)

export default component.exports